


















































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Card } from 'element-ui';

// Types
import { MilestoneFields } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    'el-card': Card
  }
})
export default class Drayage extends Vue {
  @Prop({ required: true }) private drayageBookings!: MilestoneFields[];

  get latestUpdate() {
    const ascUpdatedAts = this.drayageBookings
      .map((drayageBooking) => drayageBooking.updatedAt)
      .sort();
    const latestUpdate = ascUpdatedAts[ascUpdatedAts.length - 1];
    return this.$d(new Date(latestUpdate), 'datetime', this.$i18n.locale);
  }

  eventDateFormat(eventDate: string) {
    if (!eventDate) return '';

    const regex = /T00:00:00Z/;
    if (eventDate.match(regex)) {
      return this.$d(new Date(eventDate), 'medium', this.$i18n.locale);
    } else {
      return this.$d(new Date(eventDate), 'longutc', this.$i18n.locale);
    }
  }
}
